import { Checkbox } from 'antd'
import styled from 'styled-components'

const StyledIngredientDiscrepancyCheckbox = styled(Checkbox)`
  margin-right: 6px;
`

export default StyledIngredientDiscrepancyCheckbox
